import { render, staticRenderFns } from "./AutorizationRow.vue?vue&type=template&id=dc7457b4&scoped=true&"
import script from "./AutorizationRow.vue?vue&type=script&lang=js&"
export * from "./AutorizationRow.vue?vue&type=script&lang=js&"
import style0 from "./AutorizationRow.vue?vue&type=style&index=0&id=dc7457b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7457b4",
  null
  
)

export default component.exports